import {BlobDto} from '../Blob/type'
import {UserDto} from '../User/type'
import {XpertKnowledgeCommentDto} from '../XpertKnowledgeComment/type'
import {XpertKnowledgeTutorialDto} from '../XpertKnowledgeTutorial/type'

export interface XpertKnowledgeDto {
  id: string
  reference: string
  agentXpertCustomFields?: Record<string, any>
  callRoutingId?: string
  meetingId: string
  meetingReportId?: string
  createdAt: string
  recordingFilename: string
  recordingTimestamp?: string
  mergedJsonFilename?: string
  mergedJsonTimestamp?: string
  countsOfActivitiesTypes: number
  publishTutorial?: XpertKnowledgeTutorialDto
  isMine: boolean
  creator?: UserDto
  status: XpertKnowledgeStatus
  overallQualityScore?: number
  isPublic: boolean
}

export enum XpertKnowledgeStatus {
  WAITING_FOR_FILE = 'WAITING_FOR_FILE',
  IN_GENERATION = 'IN_GENERATION',
  DONE = 'DONE',
  CANCELED = 'CANCELED',
  FAILED_GENERATION = 'FAILED_GENERATION',
  FAILED_RECEIVE_FILE = 'FAILED_RECEIVE_FILE',
  FAILED_EMPTY_TRANSCRIPT = 'FAILED_EMPTY_TRANSCRIPT',
}

export interface RegenerateXpertKnowledgeBody {
  xpertKnowledgeId: string
}

export interface DeleteXpertKnowledgeBody {
  xpertKnowledgeId: string
}

export interface UpdateXpertKnowledgeBody {
  xpertKnowledgeId: string
}

export interface SubmitXpertKnowledgeRatingBody {
  xpertKnowledgeId: string
  tutorialId: number
  rating: number
}

export interface SubmitXpertKnowledgePublicRatingBody {
  xpertKnowledgeId: string
  rating: number
  guid: string
}

export interface TryPromptXpertKnowledgeTutorialBody {
  userPrompt: string
  systemPrompt: string
  jsonSchema: Record<string, any>
  temperature?: number
  llmModel?: LlmType
}

export interface XpertKnowledgeAssetsDto {
  xkId: string
  mergedJsonBlob: Record<string, any>
  recordingBlob: BlobDto
}

export enum LlmType {
  GPT_41 = 'GPT-4.1',
  GPT_4o = 'GPT-4o',
  GEMINI_25_PRO = 'GEMINI-2.5-PRO',
  CLAUDE_37 = 'CLAUDE-3.7',
  CLAUDE_4 = 'CLAUDE-4.0',
}

export enum SortByEnum {
  DEFAULT = 'default',
  TITLE = 'title',
  RATING = 'rating',
  VIEWS = 'views',
}
